(function () {
  /*
   * JS EDITIONS — règle Dibond / 30×45
   * -----------------------------------------------------------
   * L'Aluminium Dibond n'existe pas en 30×45 cm (cf. CLAUDE.md §20).
   * - L'option 30×45 est masquée dès que "Aluminium Dibond" est
   *   sélectionné comme finition.
   * - Si l'utilisateur était déjà en 30×45 et bascule sur Dibond,
   *   on sélectionne automatiquement 40×60 à sa place, via un
   *   vrai clic simulé pour que Shopify recalcule normalement
   *   variante, prix, média, URL et disponibilité.
   */

  const SIZE_OPTION = 'Taille';
  const FINISH_OPTION = 'Finition';
  const UNAVAILABLE_SIZE = '30 × 45 cm';
  const FALLBACK_SIZE = '40 × 60 cm';
  const DIBOND_FINISH = 'Aluminium Dibond';

  let jseAutoChangingSize = false;

  function getSelectedValue(picker, optionName) {
    const input = picker.querySelector('input[data-option-name="' + optionName + '"]:checked');
    return input ? input.value.trim() : null;
  }

  function findSizeInput(picker, value) {
    return Array.from(picker.querySelectorAll('input[data-option-name="' + SIZE_OPTION + '"]'))
      .find(function (input) { return input.value.trim() === value; });
  }

  function getPicker(productId) {
    return document.querySelector('.jse-variant-picker[data-product-id="' + productId + '"]');
  }

  // N'affiche que la description de la finition actuellement sélectionnée
  // (jse-finish-hint vit hors du picker, à côté, d'où le ciblage par productId).
  function updateFinishHint(productId) {
    const hint = document.querySelector('.jse-finish-hint[data-product-id="' + productId + '"]');
    const picker = getPicker(productId);
    if (!hint || !picker) return;

    const finish = getSelectedValue(picker, FINISH_OPTION);
    const isDibond = finish === DIBOND_FINISH;

    hint.querySelectorAll('.jse-finish-hint__desc').forEach(function (p) {
      const isDibondDesc = p.dataset.finishGroup === 'dibond';
      p.hidden = isDibondDesc !== isDibond;
    });
  }

  // Masque/affiche l'option 30×45 selon la finition actuellement sélectionnée.
  function hideDibond30x45(picker) {
    if (!picker) return;

    const size30 = findSizeInput(picker, UNAVAILABLE_SIZE);
    if (!size30) return;

    const label = size30.closest('.variant-option__button-label');
    if (!label) return;

    const finish = getSelectedValue(picker, FINISH_OPTION);
    label.classList.toggle('jse-hidden-option', finish === DIBOND_FINISH);
  }

  // Bascule vers 40×60 après un passage à Dibond depuis 30×45.
  // Shopify peut reconstruire le picker après le changement de finition,
  // donc on réessaie à quelques intervalles courts plutôt qu'une seule fois.
  function select40x60AfterDibond(productId) {
    const retryDelays = [50, 150, 300];

    retryDelays.forEach(function (delay) {
      setTimeout(function () {
        if (!jseAutoChangingSize) return;

        const picker = getPicker(productId);
        if (!picker) return;

        // Abandonne si la finition a de nouveau changé entre-temps.
        if (getSelectedValue(picker, FINISH_OPTION) !== DIBOND_FINISH) {
          jseAutoChangingSize = false;
          return;
        }

        const size40 = findSizeInput(picker, FALLBACK_SIZE);
        if (!size40) return;

        if (size40.checked) {
          jseAutoChangingSize = false;
          hideDibond30x45(picker);
          return;
        }

        // Vrai clic utilisateur simulé : Shopify met à jour variante,
        // prix, bouton panier, médias, URL et disponibilité normalement.
        size40.click();
        jseAutoChangingSize = false;

        requestAnimationFrame(function () {
          hideDibond30x45(getPicker(productId));
        });
      }, delay);
    });
  }

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input.matches('.jse-variant-picker input[type="radio"]')) return;

    const picker = input.closest('.jse-variant-picker');
    if (!picker) return;

    const productId = picker.dataset.productId;

    if (input.dataset.optionName === FINISH_OPTION) {
      const newFinish = input.value.trim();
      // La taille sélectionnée doit être lue avant que Shopify ne
      // reconstruise le picker suite au changement de finition.
      const selectedSize = getSelectedValue(picker, SIZE_OPTION);

      if (newFinish === DIBOND_FINISH && selectedSize === UNAVAILABLE_SIZE) {
        jseAutoChangingSize = true;
        select40x60AfterDibond(productId);
      }
    }

    // Réapplique le masquage après chaque changement, une fois le
    // picker éventuellement reconstruit par Shopify.
    setTimeout(function () {
      hideDibond30x45(getPicker(productId));
      updateFinishHint(productId);
    }, 120);
  });

  function init() {
    document.querySelectorAll('.jse-variant-picker').forEach(function (picker) {
      hideDibond30x45(picker);
      updateFinishHint(picker.dataset.productId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Réinitialise après un re-rendu de section dans l'éditeur Shopify.
  document.addEventListener('shopify:section:load', init);
})();
